import './App.css';
import Home from './pages/Home';
import FounderNew from './pages/FounderNew';
import PressNew from './pages/PressNew';
import Team from './pages/Team';
import Ventures from './pages/Ventures';
import Contact from './pages/Contact';
import ImpactReport from './pages/ImpactReport';
import FreeReportViewer from './pages/FreeReportViewer';
import PremiumReportViewer from './pages/PremiumReportViewer';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ventures" element={<Ventures />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/founder" element={<FounderNew />} />
            <Route path="/press" element={<PressNew />} />
            <Route path="/team" element={<Team />} />
            <Route path="/impact-report" element={<ImpactReport />} />
            <Route path="/impact" element={<ImpactReport />} />
            <Route path="/reports/free" element={<FreeReportViewer />} />
            <Route path="/reports/premium" element={<PremiumReportViewer />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
          <Toaster />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
